
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, ShieldAlert, ShieldCheck, Baby, Heart, Users, Coffee, Skull } from 'lucide-react';

interface AppropriatenessSliderProps {
  value: number;
  onChange: (val: number) => void;
}

const AppropriatenessSlider: React.FC<AppropriatenessSliderProps> = ({ value, onChange }) => {
  const levels = [
    { label: 'Strict', icon: Baby, desc: 'Toddlers' },
    { label: 'Safe', icon: Heart, desc: 'Young Kids' },
    { label: 'Balanced', icon: Users, desc: 'School-age' },
    { label: 'Relaxed', icon: Coffee, desc: 'Pre-teens' },
    { label: 'Mature', icon: Skull, desc: 'Teens+' },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-2">
        <span className="text-[#d4af37] text-xs font-bold uppercase tracking-widest">Appropriateness Level</span>
        <span className="text-[10px] text-white/60 font-serif-elegant italic">Tap to set strictness</span>
      </div>
      
      <div className="relative h-12 flex items-center bg-[#1a0101]/60 rounded-full px-2 border border-[#d4af37]/20">
        <div className="absolute inset-x-4 h-0.5 bg-[#d4af37]/20"></div>
        
        {levels.map((level, i) => {
          const isActive = value === i + 1;
          return (
            <button
              key={i}
              type="button"
              onClick={() => onChange(i + 1)}
              className="relative flex-1 flex flex-col items-center justify-center z-10 transition-all duration-300"
            >
              <motion.div
                animate={{
                  scale: isActive ? 1.2 : 0.8,
                  backgroundColor: isActive ? '#d4af37' : 'rgba(212,175,55,0.1)',
                  boxShadow: isActive ? '0 0 15px rgba(212,175,55,0.5)' : 'none'
                }}
                className={`w-8 h-8 rounded-full flex items-center justify-center border border-[#d4af37]/40 ${isActive ? 'text-black' : 'text-[#d4af37]'}`}
              >
                <level.icon size={14} />
              </motion.div>
              <motion.div 
                animate={{ opacity: isActive ? 1 : 0.4, y: isActive ? 4 : 8 }}
                className="absolute -bottom-6 flex flex-col items-center"
              >
                <span className={`text-[8px] font-bold uppercase tracking-tighter whitespace-nowrap ${isActive ? 'text-[#d4af37]' : 'text-white/40'}`}>
                  {level.label}
                </span>
              </motion.div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default AppropriatenessSlider;
